<template>
  <sweet-modal ref="link-config" :title="$t('ct-button-user-config-link')" width="50vw">

    <div v-if="element && element.internal_config">
      <div class="form-group row">
        <span class="col-12 title-principal">{{ $t('ct-register') }}</span>

        <!--        <label class="col-sm-7 col-form-label pt-0">{{ $t('ct-members-btn-register-areas') }}</label>-->
        <!--        <div class="col-sm-5 mb-2" v-if="restricts_website">-->
        <!--          <div class="form-check" v-for="(area, index) in restricts_website" :key="index">-->
        <!--            <input class="form-check-input" type="checkbox" v-model="element.internal_config.areas" :value="area.id" :id="`user-${area.id}`">-->
        <!--            <label class="form-check-label" :for="`user-${area.id}`">-->
        <!--              {{ area.name}} ({{ $t(`ct-${area.restrict_area_type.key}`)}})-->
        <!--            </label>-->
        <!--          </div>-->
        <!--          <small class="form-text text-muted">{{ $t('ct-members-link-area-helper') }}</small>-->
        <!--        </div>-->
        <!--        <div v-else>-->

        <!--        </div>-->
        <template v-if="hasElearning().length > 0">
          <div class="col-sm-7 col-form-label">
            <label for="restrict-redirection-register">{{ $t('ct-btn-user-redirect-elearning') }}</label>
          </div>

          <div class="col-sm-5 d-flex flex-column pt-2">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="restrict_elearning_course_register" value="0"
                     id="redirect-normally-register"
                     v-model="element.internal_config.links.linkRegister.value.redirect_elearning_course">
              <label class="form-check-label" for="redirect-normally-register">{{ $t('ct-redirect-page-normally') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="restrict_elearning_course_register" value="1"
                     id="redirect-course-register"
                     v-model="element.internal_config.links.linkRegister.value.redirect_elearning_course">
              <label class="form-check-label" for="redirect-course-register">{{ $t('ct-redirect-elearning-course')}}</label>
            </div>
          </div>
        </template>

        <template v-if="hasElearning().length === 0 || !parseInt(element.internal_config.links.linkRegister.value.redirect_elearning_course)">

          <div class="col-sm-7 col-form-label">
            <label for="restrict-redirection-register">{{ $t('ct-members-btn-after-register') }}</label>
          </div>

          <div class="col-sm-5 d-flex align-items-center">
            <select name="restrict_redirection" id="restrict-redirection-register"
                    v-model="element.internal_config.links.linkRegister.value.redirect"
                    class="form-control">
              <option value="0">{{ $t('ct-page-members-selected') }}</option>
              <option v-for="(page) in pages" v-bind:value="page.page_id">{{ page.page_name}}</option>
            </select>
          </div>
        </template>
      </div>

      <div class="form-group row">
        <span class="col-12 title-principal">{{ $t('ct-login') }}</span>

        <template v-if="hasElearning().length > 0">
          <div class="col-sm-7 col-form-label">
            <label for="restrict-redirection-register">{{ $t('ct-btn-user-redirect-elearning') }}</label>
          </div>

          <div class="col-sm-5 d-flex flex-column pt-2">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="restrict_elearning_course_login" value="0"
                     id="redirect-normally-login"
                     v-model="element.internal_config.links.linkLogin.value.redirect_elearning_course">
              <label class="form-check-label" for="redirect-normally-login">{{ $t('ct-redirect-page-normally') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="restrict_elearning_course_login" value="1"
                     id="redirect-course-login"
                     v-model="element.internal_config.links.linkLogin.value.redirect_elearning_course">
              <label class="form-check-label" for="redirect-course-login">{{ $t('ct-redirect-elearning-course')}}</label>
            </div>
          </div>
        </template>

        <template
          v-if="hasElearning().length === 0 || !parseInt(element.internal_config.links.linkLogin.value.redirect_elearning_course)">
          <div class="col-sm-7 col-form-label">
            <label for="restrict-redirection-login">{{ $t('ct-members-btn-after-login') }}</label>
            <!--           <p class="mb-0">{{ $t('ct-members-after-register-empty-help') }}</p>-->
          </div>
          <div class="col-sm-5 d-flex align-items-center">
            <select name="restrict_redirection" id="restrict-redirection-login"
                    v-model="element.internal_config.links.linkLogin.value.redirect"
                    class="form-control">
              <option value="0">{{ $t('ct-page-members-selected') }}</option>
              <option v-for="(page) in pages" v-bind:value="page.page_id">{{ page.page_name}}</option>
            </select>
          </div>
        </template>
      </div>

      <div class="form-group row">
        <span class="col-12 title-principal">{{ $t('ct-logout') }}</span>
        <div class="col-sm-7 col-form-label">
          <label for="restrict-redirection-logout">{{ $t('ct-members-btn-after-logout') }}</label>
<!--          <p class="mb-0">{{ $t('ct-members-after-register-empty-help') }}</p>-->
        </div>
        <div class="col-sm-5 d-flex align-items-center">
          <select name="restrict_redirection" id="restrict-redirection-logout" v-model="element.internal_config.links.linkLogout.value.redirect"
                  class="form-control">
            <option value="0">{{ $t('ct-page-members-selected') }}</option>
            <option v-for="(page) in pages" v-bind:value="page.page_id">{{ page.page_name}}</option>
          </select>
        </div>
      </div>
    </div>

    <button
      slot="button"
      class="btn btn-success"
      @click.prevent="save"
    >{{ $t('ct-save') }}
    </button>
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import {getAll as getAllRestrict} from '../../../../../js/services/restrictArea/restrictArea';
import {getWebsiteLink} from '../../../../../js/services/editor/link';

export default {
  name: 'ConfigLink',
  props: ['website_id'],
  components: {
    SweetModal
  },
  data() {
    return {
      element: false,
      callback: false,
      restricts_website: [],
      pages: [],
    };
  },
  methods: {
    init(config, callback = false) {
      this.element = config;
      this.callback = callback;
      this.pages = [];

      this.$loading.show();

      let vm = this;
      getWebsiteLink(this.website_id).then(res => {
        res.data.layouts.forEach(layout => {
          layout.pages.forEach(page => {
            vm.pages.push({
              page_id: page.id,
              page_name: page.name
            });
          });
        });
      });

      getAllRestrict(this.website_id)
        .then(response => {
          if (response.data.success) {
            this.restricts_website = response.data.data;
          }
        })
        .finally(() => this.$loading.hide())
        .catch(() => {
        });
    },

    hasElearning(){
      return this.restricts_website.filter( area => parseInt(area.elearning_course_id));
    },

    openModal() {
      this.$refs['link-config'].open();
    },

    save() {
      let value = this.element.internal_config;

      this.element.internal_config = Object.assign({}, this.element.internal_config, value);
      this.$refs['link-config'].close();
    },

    editLink(type) {
      let vm = this;
      let typeValue = type.charAt(0).toUpperCase() + type.slice(1);
      this.$root.$emit('linkComponentShow', this.element, this.element.internal_config.links[`link${typeValue}`], (value) => {
        vm.element.internal_config.links[`link${typeValue}`] = Object.assign({}, vm.element.internal_config.links[`link${typeValue}`], value);
      });
    }
  },
};
</script>

<style scoped>
  .title-principal {
    color: rgb(67, 67, 67);
    display: inline-block;
    font-size: 16px;
    margin: 10px 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Members/ButtonUser/ConfigLink.vue